import React, { useState } from "react";
import styles from "./TimeSelectionView.module.css";
import DayPartPopOver from "./DayPartPopOver";
import ReasonPopOver from "./ReasonPopOver";

interface TimeSelectionSelectionHeaderProps {
    subtitle?: string;
    showToolTip?: boolean;
    message?: string;
    header: string;
    popoverTitle?: string;
}

const TimeSelectionSelectionHeader: React.FC<TimeSelectionSelectionHeaderProps> = ({
    subtitle,
    showToolTip = true,
    message,
    header,
    popoverTitle,
}) => {

    return (
        <div className={styles.header}>
            <div className={styles.headerRow}>
                <div className={styles.headerTitle}>{header}</div>
                {showToolTip && <DayPartPopOver />}
            </div>
            {subtitle && <div className={styles.headerSubtitle}>{subtitle}</div>}
            {message && <div className={styles.headerRow}>
                <div className={styles.secondaryHeader}>
                    {popoverTitle ?? "Why these options?"}
                </div>
                <ReasonPopOver message={message} title={popoverTitle} />
            </div>}
        </div>
    );
};

export default TimeSelectionSelectionHeader;
